export class Proximity {
    proximityId: string;
    proximityDestinationFlag: boolean;
    stations: string[];
    time: number;
    isNew: boolean;
    isEdited: boolean;
    isDeleted: boolean;
}